import { Group, Line3, Mesh, Quaternion, Vector3 } from 'three';
import { getEdgeSphere } from '@/Engine/Ruler/EdgeSphere';
import { LineDotted } from '@/Engine/Primitives/LineDotted';
import { TextMesh } from '@/Engine/Ruler/TextMesh';

export class TextLine {
    model: Group = new Group();
    line: Line3;
    edgeLine1: Mesh;
    edgeLine2: Mesh;
    dottedLine: LineDotted;
    textMesh: TextMesh;

    constructor(line:Line3) {
        this.line = line;

        this.dottedLine = new LineDotted(line.start,line.end, 'dotted');
        this.edgeLine1 = getEdgeSphere();
        this.edgeLine2 = getEdgeSphere();
        const length = line.start.distanceTo(line.end);
        this.textMesh = new TextMesh(''+ Math.ceil(length*1000));
        this.model.add(this.dottedLine.model);
        this.model.add(this.edgeLine1);
        this.model.add(this.edgeLine2);
        this.model.add(this.textMesh.model);
        this.update(line);
        // this.model.position.copy(line.start);
        // this.model.lookAt(line.end);
    }

    update(line: Line3, quaternion: Quaternion) {
        this.edgeLine1.position.copy(line.start);
        this.edgeLine2.position.copy(line.end);
        this.dottedLine.model.removeFromParent();
        this.dottedLine = new LineDotted(line.start,line.end, 'dotted');
        this.model.add(this.dottedLine.model);
        const lineCenter:Vector3=new Vector3();
        line.getCenter(lineCenter);
        const length = line.start.distanceTo(line.end);
        // this.textMesh?.model.removeFromParent();

        this.textMesh.update(''+ Math.ceil(length*1000));
        lineCenter.y += 0.02;
        this.textMesh.model.position.copy(lineCenter);

        if (!quaternion) return;
        this.textMesh.model.rotation.setFromQuaternion(quaternion);

    }
}
